import {Container} from "@mui/material";
import styled from "styled-components";

export const BreadContainer = styled(Container)``;

export const Content = styled.div`
  font-size: 12px;
  color: #000;
  opacity: .5;
  margin: 5px 0 4px;
`;
